(function () {
    'use strict';

    angular
        .module('app.logTypes')
        .controller('LogTypesListController', LogTypesListController);

    LogTypesListController.$inject = ['$state', 'common', 'dataservice', 'bootstrap.dialog', 'config'];
    /* @ngInject */
    function LogTypesListController($state, common, dataservice, bsDialog, config) {
        var vm = this;

        vm.title = 'Log Types';
        vm.displayedItems = [];
        vm.items = [];
        vm.counts = [];
        vm.refresh = refresh;
        vm.showItemDetails = showItemDetails;
        vm.entriesForLogType = entriesForLogType;
        vm.copy = copy;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems(), getCounts()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function entriesForLogType(logTypeId) {
            for (var i = 0; i < vm.counts.length; i++) {
                if (vm.counts[i].Name == logTypeId) {
                    return vm.counts[i].ActiveCount;
                }
            }
        }

        function getCounts() {
            return dataservice.getItems('api/LogTypes/CountsOfEntries/-1').then(function (response) {
                vm.counts = response.data;
                return vm.counts;
            }, function (error) { });
        }

        function getItems() {
            return dataservice.getItems('api/LogTypes').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function showItemDetails(i) {
            return bsDialog.htmlBodyDialog(i.Title, i.Description);
        }

        function refresh() {
            getItems();
        }

        function copy(id) {
            var dto = {
                data: id
            };
            return dataservice.saveItem('api/LogTypes/Copy', dto).then(function (response) {
                var newId = response.data.Message;
                $state.transitionTo('logtypes.details', { id: newId });


            }, function (error) { });
        }

    }
})();
